import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Trophy, Gavel, Trophy as TrophyIcon, Image, Bell, Settings, LogOut, Building2, ClipboardList, CalendarDays, Star, CalendarCheck } from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/admin/players", label: "Players", icon: Users },
  { to: "/admin/trials", label: "Trials", icon: ClipboardList },
  { to: "/admin/trial-slot-bookings", label: "Slot Bookings", icon: CalendarCheck },
  { to: "/admin/teams", label: "Teams", icon: Building2 },
  { to: "/admin/auction", label: "Auction", icon: Gavel },
  { to: "/admin/matches", label: "Matches", icon: CalendarDays },
  { to: "/admin/selected-players", label: "Selected", icon: Star },
  { to: "/admin/hpl-registrations", label: "HPL Reg", icon: Trophy },
  { to: "/admin/sponsors", label: "Sponsors", icon: TrophyIcon },
  { to: "/admin/gallery", label: "Gallery", icon: Image },
  { to: "/admin/notifications", label: "Notify", icon: Bell },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const logout = () => { localStorage.removeItem("ndpl_admin_token"); nav("/admin/login"); };
  return (
    <div className="min-h-screen bg-[#050505] text-white flex">
      <aside className="w-56 border-r border-white/10 bg-[#0B132B] p-4 hidden md:flex flex-col">
        <div className="font-display text-2xl mb-8">NDPL <span className="text-[#39FF14]">ADMIN</span></div>
        <nav className="space-y-1 flex-1">
          {items.map((it) => (
            <NavLink key={it.to} end={it.exact} to={it.to} data-testid={`nav-${it.label.toLowerCase()}`}
              className={({isActive}) => `flex items-center gap-3 px-3 py-2 text-sm uppercase tracking-widest rounded ${isActive ? "bg-[#39FF14] text-black font-bold" : "text-white/70 hover:bg-white/5"}`}>
              <it.icon size={16}/> {it.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="admin-logout" onClick={logout} className="flex items-center gap-3 px-3 py-2 text-sm uppercase tracking-widest text-[#FF2442] hover:bg-white/5 rounded"><LogOut size={16}/> Logout</button>
      </aside>
      <div className="flex-1 min-w-0">
        {/* Mobile top nav */}
        <div className="md:hidden bg-[#0B132B] border-b border-white/10 p-3 overflow-x-auto flex gap-2 whitespace-nowrap">
          {items.map((it) => (
            <NavLink key={it.to} end={it.exact} to={it.to} className={({isActive}) => `px-3 py-1 text-xs uppercase ${isActive ? "text-[#39FF14]" : "text-white/60"}`}>{it.label}</NavLink>
          ))}
          <button onClick={logout} className="px-3 py-1 text-xs text-[#FF2442] uppercase">Logout</button>
        </div>
        <main className="p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
